'use client';
import Description from '@/components/Description';
import { formatPeriodRange } from '../../utils/helpers';
import { Button } from '@yaradigitallabs/ahua-react';
import type React from 'react';
import type { ProductionLine, ProductionPeriod } from '../../utils/types';
import type {
  Material,
  MaterialComponent,
  MaterialRouting,
} from '@/features/match-maker/utils/match-maker.types';
import {
  getItemDescription,
  getItemNumber,
} from '@/features/match-maker/utils/match-maker.helpers';
import { ReportStatus } from '../../enums';
import { formatDate } from '@/utils/helpers';

type RRProductionReportListHeaderProps = {
  selectedDate: string;
  facility?: ProductionLine | null;
  isLoading?: boolean;
  material?: Material | MaterialComponent | MaterialRouting | null;
  productionPeriod?: ProductionPeriod;
  onReportClick: () => void;
  isReporting: boolean;
  disableReporting: boolean;
};

const RRProductionReportListHeader: React.FC<
  RRProductionReportListHeaderProps
> = ({
  selectedDate,
  facility,
  isLoading,
  material,
  onReportClick,
  isReporting,
  disableReporting,
  productionPeriod,
}) => {
  return (
    <div className="px-8 py-3 bg-white rounded-md flex flex-col justify-between items-center lg:flex-row">
      <div className="flex justify-between lg:justify-start items-center gap-8 flex-1 lg:flex-none w-full lg:w-auto mb-4 lg:mb-0">
        <Description
          description={formatDate(selectedDate, {
            separator: '/',
            withoutTime: true,
          })}
          boldDescription
          title="Date"
          isLoading={isLoading}
        />
        <Description
          description={
            facility
              ? `${facility.facility_code} - ${facility.facility_description}`
              : '-'
          }
          boldDescription
          title="Production line"
          isLoading={isLoading}
        />
        <Description
          description={
            productionPeriod
              ? formatPeriodRange(
                  productionPeriod.start_time,
                  productionPeriod.end_time,
                  true
                )
              : '-'
          }
          boldDescription
          title="Production Period"
          isLoading={isLoading}
        />
        <Description
          description={productionPeriod?.production_order ?? '-'}
          boldDescription
          title="Production Order"
          isLoading={isLoading}
        />
        <Description
          description={material ? getItemNumber(material) : '-'}
          boldDescription
          title="Material Nr."
          isLoading={isLoading}
        />
        <Description
          description={material ? getItemDescription(material) : '-'}
          boldDescription
          title="Material description"
          isLoading={isLoading}
        />
      </div>
      {productionPeriod?.status === ReportStatus.REPORT_PENDING && (
        <div className="flex justify-between lg:justify-end items-center gap-8 flex-1 lg:flex-none w-full lg:w-auto">
          <Button
            colorConcept="brand"
            size="xs"
            variant="primary"
            onClick={onReportClick}
            loading={isLoading || isReporting}
            loadingPosition="leading"
            disabled={disableReporting}
          >
            Report
          </Button>
        </div>
      )}
    </div>
  );
};

export default RRProductionReportListHeader;
